module.exports = __webpack_public_path__ + "Gotham-Book.bd2999671a44b99dc086.svg";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Book.svg
// module id = ../../../../../src/assets/fonts/Gotham-Book.svg
// module chunks = 2